import React  from "react";
import CollapsibleSection from '../components/CollapsibleSection.jsx';
import TabbedSection from '../components/TabbedSection.jsx';
import ProductCard from '../components/ProductCard.jsx';
import Utils from '../modules/Utils.js';
import './Products.css';
import axios from 'axios';

class Products extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      groups: [],
      products: [],
      defaultOpen: true,
      loading: true
    }
  }

  componentDidMount() {
    this.setState({ loading: true });
    let products = window.myPluginSettings.products;
    let settings = window.myPluginSettings.settings || {}
    if(products != null && products.length > 0) {
      products = products.map(product => this.convertWoocommerceProduct(product));
      this.setState({
        groups: this.createGroupsWithPriceBands(products),
        products: products,
        loading: false,
        ...settings
      });
    } else {
      this.setState({
        loading: false,
        ...settings
      });
    }
  }

  convertWoocommerceProduct(product) {
    const attr = (name) => {
      const match = product.attributes?.find(a => a.name.toLowerCase() === name.toLowerCase());
      return match?.options?.[0] || '';
    };

    return {
      SizeBand: attr('Size Band'),
      PriceBand: attr('Price Band'),
      People: attr('People'),
      Name: product.name || '',
      VendorItemNo: `${attr('Brand')} ${attr('Vendor Item No.')}`.trim() || '',
      Warranty: attr('Warranty'),
      Energy: attr('Energy Rating'),
      Water: attr('Water Rating'),
      EstAnnualRunningCost: attr('Est. Annual Running Cost'),
      Description: product.description || '',
      WidthCm: product.dimensions.width || '',
      DepthCm: product.dimensions.length || '',
      HeightCm: product.dimensions.height || '',
      Group: attr('Group') || product.categories?.[0]?.name || '',
      Image: product.images?.[0]?.src || '',
      Active: product.status === 'publish' ? 'TRUE' : 'FALSE'
    };
  }

  createGroupsWithPriceBands(data) {
    const groupMap = new Map();
    const groupCounts = new Map();

    data.forEach(({ Group, PriceBand, SizeBand }) => {
      if (!groupMap.has(Group)) {
        groupMap.set(Group, new Map());
      }

      const priceMap = groupMap.get(Group);

      if (!priceMap.has(PriceBand)) {
        priceMap.set(PriceBand, new Set());
      }

      priceMap.get(PriceBand).add(SizeBand);

      // Increment product count for the group
      groupCounts.set(Group, groupCounts.get(Group) || 0 + 1);
    });

    const result = [];

    groupMap.forEach((priceMap, groupName) => {
      const tabs = [];

      priceMap.forEach((sizeSet, priceBand) => {
        sizeSet.forEach(sizeBand => {
          tabs.push({ priceBand, sizeBand });
        });
      });

      result.push({ name: groupName, count: groupCounts.get(groupName), tabs });
    });

    return result;
  }

  renderProductGroups() {
    let productsByGroup = Utils.arrayToDictionaryArray(this.state.products, 'Group');
    return this.state.groups.sort((a, b) => this.state.groupOrder.indexOf(a.name) - this.state.groupOrder.indexOf(b.name)).filter((group) => {
      return group.name != "Uncategorized";
    }).map((group) => {
      let tabHeaders = group.tabs.sort((a, b) => {
        const firstA = a.sizeBand && a.sizeBand.includes(" ") ? a.sizeBand.split(" ")[0] : a.sizeBand;
        const firstB = b.sizeBand && b.sizeBand.includes(" ") ? b.sizeBand.split(" ")[0] : b.sizeBand;
        return this.state.sizeOrder.indexOf(firstA) - this.state.sizeOrder.indexOf(firstB)
      }).map((tab) => {
        return { content:  <>
          <small>{tab.sizeBand}</small>
          <hr/>
          {tab.priceBand}
        </> }
      });

      return <div key={group.name} className="product-group">
        <CollapsibleSection 
          header={<div className="product-customer-header">
            <h2>{group.name}</h2>
            <p>All purchases include delivery, installation and removal of your old appliance.</p>
          </div>} 
          className="product-group" 
          sectionName={group.name} 
          defaultOpen={true} 
          arrowColour="white">
          <TabbedSection id={group.name} tabs={tabHeaders}>
            {this.renderProductGroupTabs(group, productsByGroup)}
          </TabbedSection>
        </CollapsibleSection>
      </div>
    });
  }

  renderProductGroupTabs(group, productsByGroup) {
    if(Array.isArray(productsByGroup[group.name])) {
      let productsByTab = Utils.arrayToDictionaryArray(productsByGroup[group.name], 'PriceBand');
      return group.tabs.map((tab) => {
        return <div key={`${group.name} ${tab.priceBand}`} className="product-grid" label={tab.priceBand}>
          {this.renderTabProducts(tab, productsByTab)}
        </div>
      });
    } else {
      return group.tabs.map((tab) => {
        return <div key={`${group.name} ${tab.priceBand}`} className="ta-center" label={tab.priceBand}>
          <i>(None)</i>
        </div>
      });
    }
  }

  renderTabProducts(tab, productsByTab) {
    if(Array.isArray(productsByTab[tab.priceBand])) {
      let products = productsByTab[tab.priceBand];
      return products.filter((p) => p.Active == true || p.Active == "TRUE" || p.Active == "YES").map((p) => {
        return <ProductCard
          key={p.VendorItemNo}
          product={p}
        />
      });
    }
  }

  renderLoader() {
    return <div className="ta-center">
      <div className="loadingio-spinner-rolling-38kwib0p3i3"><div className="ldio-x7umj0x3mwd">
      <div></div>
      </div></div>
    </div>
  }

  render() {
    if(this.state.loading == true) {
      return this.renderLoader()
    } else {
      return <div className="product-group-grid"> 
        {this.renderProductGroups()}
      </div>
    }
  }
}

export default Products;